import React from 'react';

import Select from 'react-select';
import makeAnimated from 'react-select/animated';

const animatedComponents = makeAnimated();
const permissionsList = [
    { label: "Dashboard Access", value: "dashboard_access" },
    { label: "View Raw Inventory", value: "view_raw_inventory" },
    { label: "View Repaired Inventory", value: "view_repaired_inventory" },
    { label: "View Main Inventory", value: "view_main_inventory" },
    { label: "Add Main Inventory", value: "add_main_inventory" },
    { label: "Add Repaired Inventory", value: "add_repaired_inventory" },
    { label: "Add Raw Inventory", value: "add_raw_inventory" },
    { label: "Manage Roles", value: "manage_roles" },
    { label: "Create Users", value: "create_users" },
    { label: "Create Departments", value: "create_departments" },
    { label: "Billing", value: "billing" },
    { label: "Search Product", value: "search_product" },
    { label: "View Transactions", value: "view_transactions" },
  ];

export default function AnimatedMulti({selectedPermission}) {
  return (
    <Select
      closeMenuOnSelect={false}
      components={animatedComponents}
      defaultValue={[permissionsList[4], permissionsList[5]]}
      isMulti
      isClearable 
      options={permissionsList}
      onChange={selectedPermission}
       placeholder="Select permissions..."
    />
  );
}